import qs from "query-string";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Fragment, useState, useEffect } from "react";
import { Alert } from "react-bootstrap";
import { clearCacheData } from "./Utils";
import { useOktaAuth } from "@okta/okta-react";
import OktaApiUtil from "configs/OktaApiUtil";
import { userLogin } from "actions/user";
import Loader from "components/commonComponents/Loader";

const LoginCallback = (props) => {
  const navigate = useNavigate();
  const [showWarning, setShowWarning] = useState(false);
  const [showWarningMsg, setShowWarningMsg] = useState();
  const [loading, setLoading] = useState(true);
  const { oktaAuth } = useOktaAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    let params = qs.parse(window.location.search);
    let code = params ? params.code : "";
    let err = params ? params.error : "";

    if (code) {
      setLoading(true);
      OktaApiUtil.getToken(code).then(async (res) => {
        const userRoles = res.tokens.accessToken.claims.pepappmcoeroles;
        const response = await dispatch(userLogin());

        if (userRoles.length && response?.success) {
          sessionStorage.removeItem("isSiteAccessErr");
          sessionStorage.removeItem("isUserSetupErr");
          // Guards against a stale flag from a previously failed external login.
          sessionStorage.removeItem("isExternalUser");
          setLoading(false);
          navigate("/dashboard", { state: { from: "login" } });
        } else {
          if (!userRoles.length) {
            sessionStorage.setItem("isSiteAccessErr", true);
          } else if (!response?.success) {
            sessionStorage.setItem("isUserSetupErr", true);
          }
          clearCacheData();
          oktaAuth.signOut("/");
        }
      });
    } else if (err) {
      setLoading(false);
      navigate("/");
    }
  }, [dispatch, navigate, oktaAuth]);

  return (
    <Fragment>
      <div className="main-wrapper">
        {loading && <Loader />}
        {/*======== WARNING ALERT MESSAGE ========*/}
        <Alert
          variant="warning"
          className="alert-popup"
          onClose={() => setShowWarning(false)}
          show={showWarning}
          dismissible
        >
          <Alert.Heading>Warning</Alert.Heading>
          <p className="mb-0">{showWarningMsg}</p>
        </Alert>
      </div>
    </Fragment>
  );
};

export default LoginCallback;
